import axios from "axios";

const db = axios.create({
    baseURL: process.env.REACT_APP_URL
})

export { db }